import { CareType } from '../graphQL';

// Care-type ordering is a frontend UI/priority concern, not a care-type config property
// today (mirrors patient-portal's `careTypeDisplayWeight`). Provider-dashboard orders
// psychiatry first, preserving the historical "no care type specified" booking default.
// This should move to a backend care-type config weight — see PDE-923 (Post-Release Care
// Type Cleanup) — at which point this map goes away.
export const careTypeDisplayWeight: Record<CareType, number> = {
  [CareType.Psychiatry]: 0,
  [CareType.Therapy]: 1,
  // Appended last so the existing psychiatry/therapy order is unchanged;
  // per-frontend Psych MD placement is owned by PDE-998.
  [CareType.Psychiatrymd]: 2,
  [CareType.Psychiatryadhd]: 3,
};

export const byCareTypeWeight = (a: CareType, b: CareType): number =>
  careTypeDisplayWeight[a] - careTypeDisplayWeight[b];
